import {addHours} from 'date-fns/addHours'

import {
  cookieSecuritySettings,
  getCookie,
  setCookie
} from '@vio/core/src/_web/utils/cookies'
import {safelyGetStorageItem} from '@vio/core/src/_web/utils/persistence'
import {CookieConsentContext} from '@vio/core/src/analytics/types/Events'
import {getDomainName} from '@vio/core/src/utils/url'

export enum CookieBannerClickComponent {
  AcceptButton = 'AcceptButton',
  RejectButton = 'RejectButton',
  PreferenceCenter = 'PreferenceCenter',
  CloseButton = 'CloseButton',
  AppPage = 'AppPage'
}

const getCookieConsentId = (): string => {
  const consentId =
    safelyGetStorageItem(localStorage, 'osano_consentmanager') ?? ''

  return consentId as string
}

const getEnabledCookieGroups = (): string[] => {
  if (typeof window === 'undefined') return []
  const consent = window.Osano?.cm?.getConsent() || ''

  return Object.entries(consent)
    .filter(([, value]) => value === 'ACCEPT')
    .map(([key]) => key)
}

export const getCookieConsentContext = (): CookieConsentContext => ({
  consentId: getCookieConsentId(),
  enabledCookieGroups: getEnabledCookieGroups()
})

export const storeCookieConsentTimestamp = () => {
  setCookie('cookieConsentTimestamp', Date.now().toString(), {
    expires: 365,
    ...cookieSecuritySettings(true)
  })
}

export const openCookiePreferencesCenter = () => {
  window.Osano?.cm?.showDrawer()
}

export const getCookieConsentComponent = (consent: Record<string, string>) => {
  if (
    consent?.ANALYTICS === 'ACCEPT' ||
    consent?.PERSONALIZATION === 'ACCEPT' ||
    consent?.MARKETING === 'ACCEPT'
  ) {
    return CookieBannerClickComponent.AcceptButton
  }

  return CookieBannerClickComponent.RejectButton
}

export const getDateConfirmationTooltipShown = (): boolean =>
  Boolean(getCookie('isDateConfirmationTooltipShown'))

export const setDateConfirmationTooltipShown = (): void => {
  setCookie('isDateConfirmationTooltipShown', '1', {
    expires: addHours(new Date(), 2),
    domain: getDomainName(window.location.hostname),
    ...cookieSecuritySettings(true)
  })
}
